import type { SVGProps } from 'react'

export function GripVertical(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M7.50008 10.8335C7.96032 10.8335 8.33341 10.4604 8.33341 10.0002C8.33341 9.53993 7.96032 9.16683 7.50008 9.16683C7.03984 9.16683 6.66675 9.53993 6.66675 10.0002C6.66675 10.4604 7.03984 10.8335 7.50008 10.8335Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.50008 5.00016C7.96032 5.00016 8.33341 4.62707 8.33341 4.16683C8.33341 3.70659 7.96032 3.3335 7.50008 3.3335C7.03984 3.3335 6.66675 3.70659 6.66675 4.16683C6.66675 4.62707 7.03984 5.00016 7.50008 5.00016Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.50008 16.6668C7.96032 16.6668 8.33341 16.2937 8.33341 15.8335C8.33341 15.3733 7.96032 15.0002 7.50008 15.0002C7.03984 15.0002 6.66675 15.3733 6.66675 15.8335C6.66675 16.2937 7.03984 16.6668 7.50008 16.6668Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.5001 10.8335C12.9603 10.8335 13.3334 10.4604 13.3334 10.0002C13.3334 9.53993 12.9603 9.16683 12.5001 9.16683C12.0398 9.16683 11.6667 9.53993 11.6667 10.0002C11.6667 10.4604 12.0398 10.8335 12.5001 10.8335Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.5001 5.00016C12.9603 5.00016 13.3334 4.62707 13.3334 4.16683C13.3334 3.70659 12.9603 3.3335 12.5001 3.3335C12.0398 3.3335 11.6667 3.70659 11.6667 4.16683C11.6667 4.62707 12.0398 5.00016 12.5001 5.00016Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.5001 16.6668C12.9603 16.6668 13.3334 16.2937 13.3334 15.8335C13.3334 15.3733 12.9603 15.0002 12.5001 15.0002C12.0398 15.0002 11.6667 15.3733 11.6667 15.8335C11.6667 16.2937 12.0398 16.6668 12.5001 16.6668Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
